import { useEffect, useState } from "react";
import styles from "./SubUnit.module.scss";
import { getUnitSubUnits } from "Admin/Service/Unit";
import { useLocation } from "react-router-dom";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
import { LoadingListCard, UnitCard } from "Admin/Components";
import { List } from "antd";
const SubUnit = () => {
  const entity_id = useLocation().pathname.split("/")[3].split("-")[0];
  const entity_type = useLocation().pathname.split("/")[3].split("-")[1];
  const [data, setData] = useState({ data: [], isLoading: true });
  useEffect(() => {
    getUnitSubUnits(entity_id, entity_type, (res) => {
      handleAPIResponse(res, () => {
        setData({
          data: res.data,
          isLoading: false,
        });
      });
    });
  }, []);
  return (
    <div className={styles["sub-unit"]}>
      <LoadingListCard
        isLoading={data.isLoading}
        grid={{
          gutter: 25,
          column: 4,
        }}
        componentNum={20}
        component={
          <div className={styles["content-venue"]}>
            <List
              grid={{
                gutter: 25,
                column: 4,
              }}
              dataSource={data.data}
              renderItem={(item, index) => {
                return (
                  <List.Item key={index}>
                    <UnitCard data={item} />
                  </List.Item>
                );
              }}
            />
          </div>
        }
      />
    </div>
  );
};

export default SubUnit;
